/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import AnalysesTree from './AnalysesTree/index'
import Preview from './Preview/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CephTracing/ViewTraces/Content"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<AnalysesTree
  viewPath={`${viewPath}/AnalysesTree`}
/>
<Preview
  viewPath={`${viewPath}/Preview`}
/>
</div>
{children}
</React.Fragment>)
}